"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../../../utils/classes");
var ErrorLabel = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("strong", { className: classnames_1.default(classes_1.addClassName('error-message'), 'text-danger text-sm', className) }, children));
};
exports.default = ErrorLabel;
//# sourceMappingURL=ErrorLabel.js.map